import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import selectPerson from '@/components/select-person/genera';
import { updateTempScope, getDocTempScope } from '@/api/notice/documentApi.js';
export default {
  data: function data() {
    var groupMap = [{
      title: '组织',
      value: 0
    }];
    return {
      groupMap: groupMap,
      mode: undefined,
      form: {},
      previewSrc: '',
      groupsList: {
        organData: [],
        postData: [],
        userData: []
      }
    };
  },
  components: {
    selectPerson: selectPerson
  },
  methods: {
    backPage: function backPage() {
      this.$router.push({
        path: '/docNotice/doc/template'
      });
    },
    updateTempScopeClick: function updateTempScopeClick() {
      var _this = this;
      var that = this;
      var req = {
        tempId: that.form.id,
        details: []
      };
      var organData = that.groupsList.organData;
      if (organData.length > 0) {
        for (var i = 0; i < organData.length; i++) {
          req.details.push({
            organid: organData[i].actorId
          });
        }
      }
      updateTempScope(req).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('保存成功');
          that.backPage();
        }
      });
    },
    getTempScope: function getTempScope() {
      var that = this;
      getDocTempScope({
        tempId: that.form.id
      }).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data,
            organData = data.organData;
          for (var i = 0; i < organData.length; i++) {
            that.groupsList.organData.push({
              actorId: organData[i].organid,
              actorName: organData[i].organname,
              tabType: 0
            });
          }
          // console.log('postData', postData);
          // for (var i = 0; i < postData.length; i++) {
          //     that.groupsList.postData.push({
          //         actorId: postData[i].postid,
          //         organId: postData[i].organid
          //     });
          // }
          // for (var i = 0; i < userData.length; i++) {
          //     that.groupsList.userData.push({
          //         actorId: userData[i].userid
          //     });
          // }
          that.groupsList = JSON.parse(JSON.stringify(that.groupsList));
        }
      });
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    var query = this.$route.query;
    this.mode = query.mode;
    Object.assign(this.form, query.data);
    this.getTempScope();
  }
};